<template>
  <div>
    <template v-if="!getApplicationSuccess">
      <v-toolbar>
        <v-toolbar-title>
          {{ $t('Register.Apply.Title') }}
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form>
          <v-subheader class="title">{{ $t('Register.Apply.You.Header') }}</v-subheader>
          <v-text-field v-model="application.user.first_name" :label="$t('User.FirstName')" type="text"
            :rules="[rules.required]"></v-text-field>
          <v-text-field v-model="application.user.last_name" :label="$t('User.LastName')" type="text"
            :rules="[rules.required]"></v-text-field>
          <v-text-field v-model="application.user.phone_number" :label="$t('User.PhoneNumber')" type="text"
            :rules="[rules.required]"></v-text-field>
          <v-text-field v-model="application.user.email" :label="$t('User.Email')" type="text"
            :rules="[rules.required, rules.email]"></v-text-field>
          <v-text-field v-model="application.years_takt_exp" :label="$t('Register.Apply.You.Values[0]')" type="number"
            min="0" :rules="[rules.required, rules.positiveNumber]"></v-text-field>
          <v-text-field v-model="application.number_takt_projects" :label="$t('Register.Apply.You.Values[1]')"
            type="number" min="0" :rules="[rules.required, rules.positiveNumber]"></v-text-field>
          <v-text-field v-model="application.project_role" :label="$t('Register.Apply.You.Values[2]')" type="text"
            :rules="[rules.required]"></v-text-field>
          <v-textarea v-model="application.takting_usage_reason" :label="$t('Register.Apply.You.Values[3]')" type="text"
            :rules="[rules.required, rules.min5]"></v-textarea>
          <v-text-field v-model="application.linked_in_profile" :label="$t('Register.Apply.You.Values[4]')" type="text"
            :rules="[rules.linkedIn]"></v-text-field>
          <v-divider></v-divider>
          <v-subheader class="title">{{ $t('Register.Apply.Company.Header') }}</v-subheader>
          <v-text-field v-model="application.company.name" :label="$t('Register.Apply.Company.Values[0]')" type="text"
            :rules="[rules.required, rules.min5]"></v-text-field>
          <v-text-field v-model="application.company.description" :label="$t('Register.Apply.Company.Values[1]')"
            type="text" :rules="[rules.required]"></v-text-field>
          <v-divider></v-divider>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-layout column>
          <div>{{ error_message }}</div>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn @click="close()">{{ $t('Buttons.Cancel') }}</v-btn>
        <v-btn v-if="!isLoading" @click="checkApply()">{{ $t('Buttons.Apply') }}</v-btn>
        <LoadingButton v-else></LoadingButton>
      </v-card-actions>
    </template>

    <template v-else>
      <v-toolbar dark>
        <v-toolbar-title>
          {{ $t('Register.Apply.MsgTitle') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        {{ $t('Register.Apply.Msg') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close()">{{ $t('Buttons.Close') }}</v-btn>
      </v-card-actions>
    </template>
  </div>

</template>

<script>
import validators from '../../helpers/validators'
import LoadingButton from '@/components/UserFeedback/LoadingButton.component.vue'
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  components: {
    LoadingButton
  },
  data: () => ({
    rules: {},
    application: {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: ''
      },
      years_takt_exp: 0,
      number_takt_projects: 0,
      project_role: '',
      takting_usage_reason: '',
      linked_in_profile: '',
      company: {
        name: '',
        description: ''
      }
    },
    passwordConfirmation: '',
    form_projects: [{
      name: '',
      image: null
    }],
    valid: false,
    error_message: ''
  }),
  computed: {
    ...mapGetters('Application', [
      'isLoading',
      'getApplicationSuccess'
    ])
  },
  methods: {
    addProject() {
      this.form_projects.push({
        name: '',
        image: null
      });
    },
    removeProject(index) {
      this.form_projects.splice(index, 1);
    },
    checkApply() {
      let self = this;
      this.error_message = '';

      if (validators.email(this.application.user.email) != true) {
        this.error_message = validators.email(this.application.user.email);
      } else {
        this.application.years_takt_exp = parseInt(this.application.years_takt_exp);
        this.application.number_takt_projects = parseInt(this.application.number_takt_projects);
        this.application.projects = [];
        let images = [];
        for (var i = 0; i < this.form_projects.length; i++) {
          this.application.projects.push({
            name: this.form_projects[i].name
          });
          let formData = new FormData();
          formData.append('image', this.form_projects[i].image);
          images.push(formData);
        }
        this.apply({
          application: this.application,
          images: images
        }).catch(err => {
          self.error_message = err.msg;
        });
      }
    },
    close() {
      this.setRegisterShow(false);
      var self = this
      setTimeout(function () {
        self.$router.push({
          name: 'Home'
        })
      }, 150);
    },
    ...mapActions('Application', [
      'requestApplicationRankings',
      'apply'
    ]),
    ...mapActions('View', [
      'setRegisterShow'
    ])
  },
  created() {
    this.rules = validators;
  }
}
</script>
